import React from "react";
import { DropTarget } from "react-dnd";
import styles from "./DustbinMatch.module.css";

export const Dustbin = ({
  getPicture,
  isOver,
  canDrop,
  connectDropTarget,
  lastDroppedItem
}) => {
  const backgroundColor = lastDroppedItem ? "#003057" : "white";
  const display = lastDroppedItem ? "none" : "block";

  return connectDropTarget(
      <div className={styles.dustbin_match_container}>
          <div className={styles.bottom_key} style={{ display }}></div>
          <div className={styles.dustbin_match} style={{ backgroundColor }}>
              <div>
                  <img
                      src={`${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/${getPicture}`}
                      className={styles.dustbin_match_img}
                      alt="Dust-bin"
                  />
              </div>
          </div>
      </div>
  );
};
export default DropTarget(
    props => props.accepts,
    {
        drop(props, monitor) {
            props.onDrop(monitor.getItem());
        }
    },
    (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
    })
)(Dustbin);
